import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FaRupeeSign ,FaPhone } from "react-icons/fa";

export default function MyWallet() {
  const [amount, setAmount] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [walletHistory, setWalletHistory] = useState([]);
  const [themeColor, setThemeColor] = useState("#fffff");
  const [webFont, setWebFont] = useState("");
  const [activeBtn, setActiveBtn] = useState("All");

  const adminId = sessionStorage.getItem("admin_auto_id");
  const customerId = sessionStorage.getItem("accessToken");
  const appTypeId = sessionStorage.getItem("app_type_id");
  const [message, setMessage] = useState(""); // State for message
  const [messageType, setMessageType] = useState(""); 

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour)
    }
  }, []);

function lightenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) + 255 * percent;
  let g = ((num >> 8) & 0x00ff) + 255 * percent;
  let b = (num & 0x0000ff) + 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}

function darkenHexColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  let r = (num >> 16) - 255 * percent;
  let g = ((num >> 8) & 0x00ff) - 255 * percent;
  let b = (num & 0x0000ff) - 255 * percent;

  r = Math.max(0, Math.min(255, Math.round(r)));
  g = Math.max(0, Math.min(255, Math.round(g)));
  b = Math.max(0, Math.min(255, Math.round(b)));

  return `rgb(${r}, ${g}, ${b})`;
}



  useEffect(() => {
    fetchWalletBalance();
    fetchWalletHistory();
  }, []);

  const fetchWalletBalance = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_my_wallet`,
        {
          admin_auto_id: adminId,
          customer_auto_id: customerId,
          app_type_id: appTypeId,
        }
      );
      if (response.data.status === "1") {
        setWalletBalance(parseFloat(response.data.data[0].amount));
      }
    } catch (err) {
      console.error("Error fetching wallet balance:", err);
    }
  };

  const fetchWalletHistory = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_my_wallet_history`,
        {
          admin_auto_id: adminId,
          customer_auto_id: customerId,
          app_type_id: appTypeId,
        }
      );
      if (response.data.status === "1") {
        setWalletHistory(response.data.data);
      }
    } catch (err) {
      console.error("Error fetching wallet history:", err);
    }
  };

  const handlePayNow = async () => {
    if (!amount || isNaN(amount)) {
      setMessage("Please enter a valid amount");
      setMessageType("error");
      setTimeout(() => setMessage(""), 2000); // Clear message after 2 seconds
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/add_my_wallet`,
        {
          admin_auto_id: adminId,
          customer_auto_id: customerId,
          app_type_id: appTypeId,
          amount: parseFloat(amount),
        }
      );

      if (response.data.status === "1") {
        setMessage("Amount added to wallet successfully");
        setMessageType("success");
        setAmount("");
        fetchWalletBalance();
        fetchWalletHistory();
        setTimeout(() => setMessage(""), 2000);
      }
    } catch (err) {
      setMessage("Error adding amount");
      setMessageType("error");
      setTimeout(() => setMessage(""), 2000);
      console.log(err);
    }
  };
  

    const filteredHistory = walletHistory.filter((entry) => {
    if (activeBtn === "Credited")
      return entry.amount && parseFloat(entry.amount) > 0;
    if (activeBtn === "Debited")
      return entry.deducted_amount && parseFloat(entry.deducted_amount) > 0;
    return true;
  });

  return (
  <div className={`p-6 ${webFont}`}>
   <div className="m-3 p-6 shadow-xl flex flex-col items-center text-center bg-gray-100 rounded-lg relative">
        <span className="text-sm text-black font-bold">
          TOTAL AVAILABLE BALANCE
        </span>

        <span className="text-black font-bold text-3xl p-3 flex items-center justify-center">
          <FaRupeeSign className="mr-2" />
          {walletBalance.toFixed(2)}
        </span>

        <div className="w-full flex flex-col items-center gap-3 relative">
          <input
            type="number"
            placeholder="Enter Amount"
            className="p-2 border rounded-md w-full max-w-xs text-center"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />

          <div className="flex gap-4">
            {[100, 500, 1000].map((value) => (
              <label key={value} className="flex items-center gap-1">
                <input
                  type="radio"
                  name="amount"
                  value={value}
                  checked={amount === value.toString()}
                  onChange={() => setAmount(value.toString())}
                />
                {value}
              </label>
            ))}
          </div>

          <button
            className="py-2 px-4 rounded-xl text-white w-full max-w-xs mt-3"
            style={{ backgroundColor: themeColor }}
            onClick={handlePayNow}
          >
            Submit
          </button>

          {message && (
            <span
              className={`absolute top-[5.5rem] text-sm ${
                messageType === "success" ? "text-green-600" : "text-red-600"
              }`}
            >
              {message}
            </span>
          )}
        </div>
      </div>
      <div className="grid">
        <div className="grid m-3 overflow-auto max-h-96">
          <div className="gap-32 justify-between flex p-2 shadow-xl">
            <button
              className={`p-2 ${
                activeBtn === "All" ? "border-b " : "text-black"
              }`}
              onClick={() => setActiveBtn("All")}
              style={{borderColor:activeBtn === "All" ? themeColor : ""}}
            >
              All
            </button>
            <button
              className={`p-2 ${
                activeBtn === "Credited"
                  ? "border-b"
                  : "text-black"
              }`}
              onClick={() => setActiveBtn("Credited")}
              style={{borderColor:activeBtn === "All" ? themeColor : ""}}
            >
              Credited
            </button>
            <button
              className={`p-2 ${
                activeBtn === "Debited"
                  ? "border-b "
                  : "text-black"
              }`}
              onClick={() => setActiveBtn("Debited")}
              style={{borderColor:activeBtn === "All" ? themeColor : ""}}
            >
              Debited
            </button>
          
          </div>
          <div className=" text-center w-full overflow-x-auto">
            <table className="w-full border rounded text-sm">
              <thead className="sticky top-0 z-10 text-left bg-gray-200">
                <tr>
                  <th className="px-4 py-2 border-b">Sr No.</th>
                  <th className="px-4 py-2 border-b">Order No.</th>
                  {activeBtn === "All" ? (
                    <th className="px-4 py-2 border-b">Amount</th>
                  ) : (
                    <>
                      {activeBtn !== "Credited" && (
                        <th className="px-4 py-2 border-b">Debit</th>
                      )}
                      {activeBtn !== "Debited" && (
                        <th className="px-4 py-2 border-b">Credit</th>
                      )}
                    </>
                  )}
                  <th className="px-4 py-2 border-b">Date</th>
                  <th className="px-4 py-2 border-b">Time</th>
                </tr>
              </thead>
              <tbody>
                {filteredHistory.length > 0 ? (
                  filteredHistory.map((entry, index) => (
                    <tr key={entry._id} className="hover:bg-gray-50 text-left">
                      <td className="px-4 py-2 border-b">{index + 1}</td>
                      <td className="px-4 py-2 border-b">{entry._id}</td>

                      {activeBtn === "All" ? (
                        <td
                          className={`px-4 py-2 border-b font-medium ${
                            parseFloat(entry.amount) > 0 ||
                            parseFloat(entry.refunded_amount) > 0
                              ? "text-green-600"
                              : parseFloat(entry.deducted_amount) > 0
                              ? "text-red-600"
                              : ""
                          }`}
                        >
                          ₹{" "}
                          {parseFloat(entry.amount) > 0
                            ? parseFloat(entry.amount).toFixed(2)
                            : parseFloat(entry.refunded_amount) > 0
                            ? parseFloat(entry.refunded_amount).toFixed(2)
                            : parseFloat(entry.deducted_amount).toFixed(2)}
                        </td>
                      ) : (
                        <>
                          {activeBtn !== "Credited" && (
                            <td className="px-4 py-2 border-b text-red-600 font-medium">
                              {entry.deducted_amount
                                ? `₹ ${parseFloat(
                                    entry.deducted_amount
                                  ).toFixed(2)}`
                                : "-"}
                            </td>
                          )}
                          {activeBtn !== "Debited" && (
                            <td className="px-4 py-2 border-b text-green-600 font-medium">
                              {entry.amount
                                ? `₹ ${parseFloat(entry.amount).toFixed(2)}`
                                : "-"}
                            </td>
                          )}
                        </>
                      )}

                      <td className="px-4 py-2 border-b">
                        {entry.date || "-"}
                      </td>
                      <td className="px-4 py-2 border-b">
                        {entry.time || "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="py-4 text-center text-gray-500">
                      No transactions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
